
import { Assets } from "../list/Assets";
import styles from '../../styles/MobileCanvas.module.css';
import Image from "next/image";

export default function MobileCanvas(props) {

  const platform = props.platform;
  return (
    <>
    {platform!="pc" && (<div className={styles.thumb_canvas_Grid}>
    <div className={styles.child}><Image alt={props.name} className={`${styles.mobile_image} unset_position`} src={props.thumb} fill></Image></div>
    <div className={`${styles.child} ${styles.child1}`}>  <div className={styles.mobile_btns} onClick={props.onClick}>
      <Image
      alt="Play Now"
        className={`${styles.play_btn} unset_position`}
        src={Assets[0].m_play_btn} fill
      ></Image>
      <p className={styles.play_text}>Play Now</p>
    </div></div>
   
  
   
  </div>)}

  {platform=="pc" && (<div className={styles.thumb_canvas_Grid}>
    <div className={`${styles.child} unset_position`}><Image alt={props.name} className={styles.mobile_image} src={props.thumb} fill></Image></div>
    <div className={`${styles.child} ${styles.child1}`}>  <div className={styles.mobile_btns} >
      
    <p 
  className={styles.play_text} 
  style={{ textAlign: 'center', fontSize: '26px', margin: `0px 30px` }}
>
  This game is not available for mobile. Play it on desktop or try different games!
</p>
    </div></div>
   
  
   
  </div>)}

  </>
  ); 
}